import * as React from "react";
import ReactDOM from "react-dom";
import { Table } from "antd";

import "./MsTable.scss";

interface MsTableProps {
  [key: string]: any;
}

interface MsTableState {
  height: number
}

/**
 * 通用table，动态设置高度
 *
 * @class MsTable
 * @extends {React.Component<TableProps, MsTableState>}
 */
class MsTable extends React.Component<MsTableProps, MsTableState> {
  // 构造函数
  constructor(props: MsTableProps) {
    super(props)

    // 初始化state
    this.state = {
      height: 300
    };
  }

  // 组件加载后
  public componentDidMount() {
    // 给window添加浏览器窗口调整大小事件
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  // 组件卸载前
  public componentWillUnmount() {
    // 删除window窗口调整事件
    window.removeEventListener("resize", this.handleResize);
  }

  // 设置窗口调整回调函数
  public handleResize = () => {
    // table对象
    const table: any = ReactDOM.findDOMNode(this);
    // layout高度 - 头部64 - margin32 - padding32
    const totalHeight: number = document.querySelector("#root")!.clientHeight - 128;
    // 减去表头和分页
    let h = totalHeight - table.querySelector(".ant-table-header").offsetHeight - (56 + (this.props.otherHeight || 0));

    // 减去搜索框等
    for (const item of table.parentNode.childNodes) {
      if (item !== table && (item.style && !item.style.float)) {
        const top = item.style.marginTop;
        const bottom = item.style.marginBottom;
        h -= item.offsetHeight;

        // 减去marginTop
        if (top) {
          h -= Number(top.replace("px", ""));
        }

        // 减去marginBottom
        if (bottom) {
          h -= Number(bottom.replace("px", ""));
        }
      }
    }

    // 设置table高度
    this.setState({height: h});
  };

  public render() {
    let className = "ms-table-default";

    if (this.props.className) {
      className = this.props.className + " ms-table-default";
    }
    if (this.props.rowSelection) {
      className = this.props.className + " ms-table-default ms-table-default-row-select";
    }

    return (
      <Table
        { ...this.props }
        className={ className }
        scroll={ {y: this.state.height, ...this.props.scroll} }
        pagination={ this.props.pagination ? {
          ...this.props.pagination
        } : false }
      />
    )
  }
}

export default MsTable;



// WEBPACK FOOTER //
// ./src/components/ms-common/ms-table/MsTable.tsx